module.exports = __webpack_public_path__ + "img/style_model_preview_671.e13cf6ac.jpg";